export function normalizeQrCode(rawCodes) {
    console.log(rawCodes)

    if (!rawCodes) {
        return {id: null, claimable: false};
    }

    if (rawCodes[0].format !== 'qr_code') {
        console.log('not a qr rawCodes');
        return;
    }

    const qrCode = rawCodes[0].rawValue.toLowerCase().trim();
    if (qrCode.length === 0) {
        return {id: '', claimable: false};
    }

    if (qrCode.startsWith("!")) {
        return {
            id: qrCode.substring(1),
            claimable: true
        };
    }

    return {
        id: qrCode,
        claimable: false
    };
}